class Config {
    get _externalConfig() {
        return window.createUserCardForm || {};
    }

    get citys() {
        return this._externalConfig.citys || [];
    }

    get areas() {
        return this._externalConfig.areas || [];
    }

    get defaultArea() {
        return {
            id: -1,
            name: 'Территория города',
        };
    }

    get marker() {
        return this._externalConfig.marker || '';
    }

    get continueUrl() {
        return this._externalConfig.continueUrl || '';
    }
}

export default new Config();
